import { useEffect, useState } from "react";
import { getSessionStatus } from "./keycloak";

export default function useSessao() {
  const [sessao, setSessao] = useState(getSessionStatus);
  useEffect(() => {
    const atualizar = () => setSessao(getSessionStatus());
    window.addEventListener("esocial-session", atualizar);
    atualizar();
    return () => window.removeEventListener("esocial-session", atualizar);
  }, []);
  return sessao;
}
